import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import multiInputStyle from "../../assets/jss/material-dashboard-pro-react/components/multiInputStyle";
class MultiInput extends React.Component {
    state= {
        newValue: ''
    }
    onClick(e){
        e.preventDefault()
        if (!this.state.newValue) return;
        let {values} = this.props
        values.push(this.state.newValue)

        this.setState({newValue: ''})
        this.props.onUpdateValue(values)
    }
    removeItem(e, valueToRemove) {
        e.preventDefault()
        let {values} = this.props
        values = values.filter((i) => i !== valueToRemove)

        this.setState({...this.state})
        this.props.onUpdateValue(values)
    }
    inputChange(e) {
        this.setState({newValue: e.target.value})
    }

    render() {
        const {values} = this.props
        const {classes, placeholder} = this.props
        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} lg={6}>
                    <div style={{display: 'flex'}}>
                        <input className={classes.input} value={this.state.newValue} placeholder={placeholder} onChange={this.inputChange.bind(this)} />
                        <button
                            className={classes.addBtn}
                            onClick={(e) => this.onClick(e)}
                        >
                            ADD
                        </button>
                    </div>
                </GridItem>

                <GridItem xs={12} sm={12} md={12} lg={6}>
                    <div className={classes.valuesBox}>
                        {values.map((value, i) => {
                            return(
                                <div key={i} className={classes.valueItem}>
                                    <span>{value}</span>
                                    <span
                                      className={classes.removeItemBtn}
                                      onClick={(e) => this.removeItem(e, value)}
                                    >X</span>
                                </div>
                            )
                        })}
                    </div>

                </GridItem>
            </GridContainer> 
        )  
    }
}

MultiInput.propTypes = {
    onUpdateValue: PropTypes.func.isRequired,
    values: PropTypes.array.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default withStyles(multiInputStyle)(MultiInput)


// WEBPACK FOOTER //
// ./src/views/Components/MultiInput.jsx